import React from 'react'
import Popover from '@mui/material/Popover'
import MoreVertIcon from '@mui/icons-material/MoreVertOutlined'
import {
  IconButton,
  ListItem,
  List,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material'
import NotificationIcon from '@mui/icons-material/NotificationsOutlined'
import PersonIcon from '@mui/icons-material/PersonOutlined'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import { ISchool } from '../../interfaces/school.interface'
import SchoolLogoutListItem from '../School/SchoolLogoutListItem'
import DashboardIcon from '@mui/icons-material/Dashboard'
import HomeIcon from '@mui/icons-material/Home'
import Link from 'next/link'

export default function LinkPopoverComponent(props: {
  customStyle?: any
  schoolDetails: ISchool
  additionalTopComponents?: React.ReactNode
  additionalBottomComponents?: React.ReactNode
  hideProfileLink?: boolean
  hideBillingLink?: boolean
}) {
  const customStyle = props.customStyle
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  function handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <div>
      <IconButton
        color={'primary'}
        aria-describedby={id}
        onClick={handleClick}
        size="large"
      >
        <MoreVertIcon style={customStyle || {}} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List dense={true}>
          {props.additionalTopComponents}
          <ListItem component={Link} href={'/'} button={true}>
            <ListItemIcon>
              <HomeIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Home</ListItemText>
          </ListItem>
          <ListItem component={Link} href={'/dashboard'} button={true}>
            <ListItemIcon>
              <DashboardIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Dashboard</ListItemText>
          </ListItem>
          <ListItem component={Link} href={'/profile'} button={true}>
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Profile</ListItemText>
          </ListItem>

          <ListItem component={Link} href={'/notification'} button={true}>
            <ListItemIcon>
              <NotificationIcon
                // style={{ color: "#fff" }}
                // color="primary"
                fontSize="small"
              />
            </ListItemIcon>
            <ListItemText>Notification</ListItemText>
          </ListItem>

          <ListItem component={Link} href={'/student-billing'} button={true}>
            <ListItemIcon>
              <CreditCardIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Billing</ListItemText>
          </ListItem>
          {/* {props.schoolDetails?.show_forum && (
            <ListItem component={Link} href={'/discussion'} button={true}>
              <ListItemIcon>
                <PeopleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Community</ListItemText>
            </ListItem>
          )} */}
          <Divider />
          <SchoolLogoutListItem />
          {props.additionalBottomComponents}
        </List>
      </Popover>
    </div>
  )
}
